// extracted by mini-css-extract-plugin
export default {"root":"Rate_root__wHDQO","btn":"Rate_btn__5aRga"};